export const VILLES = [
  {
    id: 'tunis',
    label: 'Tunis',
    values: ['tunis', 'TUNIS']
  },
  {
    id: 'sousse',
    label: 'Sousse',
    values: ['sousse', 'SOUSSE', 'Souse']
  },
  {
    id: 'monastir',
    label: 'Monastir',
    values: ['monastir', 'MONASTIR']
  },
  {
    id: 'mahdia',
    label: 'Mahdia',
    values: ['mahdia', 'MAHDIA']
  },
  {
    id: 'sfax',
    label: 'Sfax',
    values: ['sfax', 'SFAX']
  },
  {
    id: 'nabeul',
    label: 'Nabeul',
    values: ['nabeul', 'NABEUL']
  },
  {
    id: 'bizerte',
    label: 'Bizerte',
    values: ['bizerte', 'BIZERTE']
  },
  {
    id: 'tabarka',
    label: 'Tabarka',
    values: ['tabarka', 'TABARKA']
  }
];
